const $ = jQuery.noConflict();

class Selects {
    constructor() {
        this.inputs = '.gfield select:visible';
    }

    init() {
        $(this.inputs).each((index, selectItem) => this.initSelect(selectItem));

        $(document).bind('gform_post_render', () => {
            $(this.inputs).each((index, selectItem) => this.initSelect(selectItem));
        });
    }

    initSelect(selectItem) {
        // Check options
        const isPlaceholder = $(selectItem).find('option:selected').length === 0 || $(selectItem).find('.gf_placeholder:selected').length;
        const title = $(selectItem).find('option:selected').length ? $(selectItem).find('option:selected').text() : 'Select Item';
        const isMultiple = selectItem.multiple;

        // Render new select
        $(selectItem).before(`
            <div class="select ${isPlaceholder ? 'select--placeholder' : ''} ${isMultiple ? 'select--multiple' : 'select--default'}">
                <div class="select__title">${title}</div>
                <ul class="select__options"></ul>
            </div>
        `);
        $(selectItem).hide();

        // Add options for select
        const options = $(selectItem).prev().find('.select__options');
        $(selectItem).find('option').each((index, option) => {
            const $option = $(option);
            if (!$option.hasClass('gf_placeholder')) {
                const optionClass = $option.is(':selected') ? 'select__option selected' : 'select__option';
                const content = isMultiple ? `<div class="select__option-checkbox"></div>${$option.text()}` : $option.text();
                options.append(`<li class="${optionClass}" data-value="${$option.attr('value')}">${content}</li>`);
            }
        });

        this.bindEvents($(selectItem).prev(), isMultiple);
    }

    bindEvents(select, isMultiple) {
        const title = select.find('.select__title');
        const options = select.find('.select__options');
        const option = select.find('.select__option');
        const defaultSelect = select.next();

        // Title click
        title.on('click', () => {
            options.slideToggle(200);
            select.toggleClass('open');
        });

        // Option click
        option.on('click', event => {
            const $option = $(event.currentTarget);
            if (isMultiple) {
                let textValues = [];
                let values = [];

                option.each((index, el) => {
                    if ($(el).hasClass('selected')) {
                        values.push($(el).attr('data-value'));
                        textValues.push($(el).text());
                    }
                });

                if ($option.hasClass('selected')) {
                    $option.removeClass('selected');
                    values = values.filter(value => value !== $option.attr('data-value'));
                    textValues = textValues.filter(value => value !== $option.text());
                } else {
                    $option.addClass('selected');
                    values.push($option.attr('data-value'));
                    textValues.push($option.text());
                }

                if (textValues.length === 0) {
                    title.text('Select Item');
                    select.addClass('select--placeholder');
                } else {
                    title.text(textValues.join(', '));
                    select.removeClass('select--placeholder');
                }

                defaultSelect.val(values);
            } else {
                if (!$option.hasClass('selected')) {
                    $option.addClass('selected').siblings().removeClass('selected');
                    options.slideUp(200);
                    select.removeClass('open');
                    title.text($option.text());
                    select.removeClass('select--placeholder');
                    defaultSelect.val($option.attr('data-value'));
                }
            }
        });
    }

    hideOutsideClick(e) {
        const selects = $('.select.open');
        if (selects.length > 0) {
            if (!selects.is(e.target) && selects.has(e.target).length === 0) {
                selects.removeClass('open').find('.select__options').slideUp(200);
            }
        }
    }
}

export default new Selects();